import React, { useState } from "react";
import useStore from "hooks/useStore";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import AmbassadorBreadcrumb, {
  AmbassadorBreadcrumbLink,
} from "components/breadcrumbs/AmbassadorBreadcrumb";
import EarnedPoints from "./component/EarnedPoints";
import UsedPoints from "./component/UsedPoints";

const Wallet = () => {
  const navigate = useNavigate();
  const breadcrumbLinks: AmbassadorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.ambassadorHome },
    { title: "Wallet", path: siteRoutes.ambassadorWallet },
  ];
  const [activeTab, setActiveTab] = useState("Earned Points");
  const {
    getAmbassadorTotalEarnedPoints,
    getAmbassadorWallet,
    getAmbassadorTotalSpentPoints,
  } = useStore();
  const totalEarnedPoints = getAmbassadorTotalEarnedPoints();
  const wallet = getAmbassadorWallet();
  const totalSpentPoints = getAmbassadorTotalSpentPoints();

  return (
    <div className="container min-h-[70vh]">
      <AmbassadorBreadcrumb links={breadcrumbLinks} />
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-black">Wallet</h1>
        <p className="text-sm text-gray-500 mt-1">Total Points Balance</p>
        <h2 className="text-3xl font-bold text-black mt-1 mb-4">
          {totalEarnedPoints} points
        </h2>

        <div className="flex flex-wrap gap-4 mb-4">
          <div className="bg-gray-50 px-4 py-2 rounded-md">
            <p className="text-xs text-gray-600">Total Available Points</p>
            <p className="text-lg font-semibold text-black">{wallet}</p>
          </div>
          <div className="bg-gray-50 px-4 py-2 rounded-md">
            <p className="text-xs text-gray-600">Used points</p>
            <p className="text-lg font-semibold text-black">
              {totalSpentPoints}
            </p>
          </div>
        </div>

        <button
          className="bg-gray-700 text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-gray-800 transition-colors"
          onClick={() => navigate(siteRoutes.ambassadorRedeemPrizePoints)}
        >
          Redeem Points
        </button>
      </div>

      {/* History Section */}
      <div>
        <h2 className="text-lg font-bold text-black mb-2">History</h2>
        <div className="flex mb-4 text-sm">
          {["Earned Points", "Used Points"].map((tab) => (
            <button
              key={tab}
              className={`mr-6 pb-2 font-medium ${
                activeTab === tab
                  ? "text-yellow-500 border-b-2 border-yellow-500"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {activeTab === "Earned Points" && <EarnedPoints />}
        {activeTab === "Used Points" && <UsedPoints />}
      </div>
    </div>
  );
};

export default Wallet;
